import * as React from "react";
import {Component } from "react";

import "./footer.scss";

import {AppState} from "../app-mobx";
import {MapState} from "../../../core/map-state";
import {UiState} from "../../../core/ui-state";
import {observer} from "mobx-react";
import {AppConfiguration} from "../../../core/config/app-configuration";
import SVG from "react-inlinesvg";
import facebookLogo from "../../../assets/images/layout/facebook.svg";
import xLogo from "../../../assets/images/layout/x.svg";


export interface FooterProps {
    view: __esri.MapView | __esri.SceneView | undefined;
    appStore: AppState;
    uiStore: UiState;
    mapStore: MapState;
    appConfig: AppConfiguration;
    handleNavigation: (route: string) => void;
}

@observer
export class ObjektwesenFooter extends Component<FooterProps, any> {

    constructor(props: FooterProps) {
        super(props);
        this.state = {
            search: null
        };
    }
    handleLocalUrl(event: React.MouseEvent): void {
        event.preventDefault();
        this.props.handleNavigation((event.target as HTMLAnchorElement).pathname);
    }
    render(): React.ReactElement | null {
        const {appStore, appConfig} = this.props;
        const {topic, mapViewerConfig} = appStore;
        const pageTitle = document.title;
        const locationHref = window.location.href;
        if (!topic) {
            return null;
        }
        const objektwesenParent = mapViewerConfig.navigation.items.find((item) => item.id === "objektwesen");
        let parentHref = appConfig.basename;
        if (objektwesenParent) {
            parentHref = parentHref + objektwesenParent.href;
        }
        parentHref = parentHref.replace("//", "/");
        return(
            <footer className="footer">
                <div className="footer__content">
                    <ul className="footer__content-linklist">
                        <li className="footer__content-link-item">
                            <a className="footer__content-link" href="https://www.lu.ch">
                                © {new Date().getFullYear()} Kanton Luzern</a><span className="line" />
                        </li>
                        <li className="footer__content-link-item">
                            <a className="footer__content-link" title="Impressum"
                                href= {parentHref+"kontakt"}
                                onClick={(event: React.MouseEvent) => this.handleLocalUrl(event)}
                            >Impressum</a><span className="line" />
                        </li>
                        <li className="footer__content-link-item">
                            <a className="footer__content-link" title="Disclaimer"
                                href="https://geoportal.lu.ch/Disclaimer"
                                rel={"noreferrer"} target="_blank">Disclaimer</a>
                        </li>
                    </ul>
                    <ul className="footer__content-social-media">
                        <li id="ctl05_liTwitter"
                            className="footer__content-social-media-item footer__content-social-media-item--x">
                            <a title="X" className="footer__content-social-media-item-url"
                                href={"https://twitter.com/intent/tweet?original_referer=" +
                                encodeURIComponent(locationHref) +
                                "&text=" + encodeURIComponent(pageTitle) + ""}
                                rel={"noreferrer"} target="_blank"><span className="sprite sprite--x">
                                    <SVG src={xLogo}/>

                                </span></a>
                        </li>
                        <li id="ctl05_liFacebook"
                            className="footer__content-social-media-item footer__content-social-media-item--facebook">
                            <a title={"Teile diese Seite auf Facebook"}
                               className="footer__content-social-media-item-url"
                               href={"https://www.facebook.com/sharer.php?u=" +
                                   encodeURIComponent(locationHref) +
                                   "&t=" + encodeURIComponent(pageTitle) + ""}
                               rel={"noreferrer"} target="_blank"><span className="sprite sprite--facebook">
                                    <SVG src={facebookLogo}/>
                                </span></a>
                        </li>
                    </ul>
                </div>

            </footer>
        );
    }
}
